import React from 'react';

export const ShutterLeftOpening = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 61 77.8"
      width="48"
      {...props}
    >
      <path fill="#fff" d="M3.2.8h54.6v67.8H3.2z" />
      <path
        d="M57.8 69.3H3.2c-.2 0-.4-.3-.4-.8V.8c-.1-.5.1-.8.4-.8h54.6c.2 0 .4.3.4.8v67.8c0 .4-.2.7-.4.7zM3.6 67.8h53.7V1.6H3.6v66.2z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M3.2.8h54.6v67.8H3.2z" />
      <path
        d="M57.8 69.3H3.2c-.2 0-.4-.3-.4-.8V.8c-.1-.5.1-.8.4-.8h54.6c.2 0 .4.3.4.8v67.8c0 .4-.2.7-.4.7zM3.6 67.8h53.7V1.6H3.6v66.2z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M5.7 5.3h49.5v58.8H5.7z" />
        <path d="M55.2 64.9H5.7c-.2 0-.4-.3-.4-.8V5.3c0-.4.2-.8.4-.8h49.5c.2 0 .4.3.4.8v58.8c.1.4-.1.8-.4.8zm-49-1.6h48.6V6H6.2v57.3z" />
      </g>
      <path
        d="M60.5 69.3H.4c-.2 0-.4-.3-.4-.7 0-.4.2-.7.4-.7h60.1c.2 0 .4.3.4.7.1.4-.1.7-.4.7z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M6 1.7l42.9 8.4.2 66.7L6 67.7z" />
        <path
          d="M49.9 77.8L5.3 68.4V.7l44.4 8.7.2 68.4zM6.8 67l41.5 8.7-.2-65L6.8 2.6V67z"
          fill="#fff"
        />
        <path fill="#233762" d="M10.6 9.5l34 6.8V21l-34-6.7z" />
        <path
          d="M45 21.6l-34.8-6.9V9.1L45 15.9v5.7zm-34-7.7l33.2 6.6v-3.9L11 10v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M10.6 14.3l34 6.7v4.8l-34-6.8z" />
        <path
          d="M45 26.3l-34.8-7v-5.6l34.8 7v5.6zm-34-7.6l33.3 6.6v-3.9L11 14.8v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M10.6 19l34 6.8v4.8l-34-6.8z" />
        <path
          d="M45 31.1l-34.9-7v-5.6l34.8 7 .1 5.6zm-34-7.7l33.3 6.7v-3.9L11 19.5v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M10.6 23.8l34 6.8v4.8l-34-6.9z" />
        <path
          d="M45 35.9l-34.9-7v-5.6l34.9 7v5.6zm-34-7.7l33.3 6.7V31L11 24.3v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M10.6 28.5l34 6.9.1 4.8-34.1-6.9z" />
        <path
          d="M45.1 40.7l-34.9-7.1V28l34.9 7v5.7zM11 32.9l33.3 6.8v-3.9L11 29.1v3.8z"
          fill="#fff"
        />
        <path fill="#233762" d="M10.6 33.3l34.1 6.9V45l-34.1-6.9z" />
        <path
          d="M45.1 45.5l-34.9-7.1v-5.6l34.9 7.1v5.6zM11 37.7l33.3 6.8v-3.9L11 33.8v3.9z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M10.6 38.1L44.7 45v4.8l-34.1-7z" />
          <path
            d="M45.1 50.3l-34.9-7.2v-5.6l34.9 7.1v5.7zM11 42.5l33.3 6.8v-3.9L11 38.6v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M10.6 42.8l34.1 7v4.8l-34.1-7z" />
          <path
            d="M45.1 55.1l-34.9-7.2v-5.6l34.9 7.2v5.6zM11 47.2l33.3 6.9v-3.9L11 43.3v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M10.6 47.6l34.1 7v4.8l-34.1-7.1z" />
          <path
            d="M45.1 59.9l-34.9-7.2v-5.6l34.9 7.2v5.6zM11 52l33.3 6.9V55L11 48.1V52z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M10.6 52.4l34.1 7.1v4.8l-34.1-7.2z" />
          <path
            d="M45.1 64.8l-34.9-7.3v-5.6l34.9 7.2v5.7zm-34.1-8l33.3 6.9v-3.9L11 52.9v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M10.6 57.1l34.1 7.2v4.8l-34.1-7.2z" />
          <path
            d="M45.1 69.6l-34.9-7.3v-5.6L45.1 64v5.6zm-34.1-8l33.3 7v-3.9l-33.3-7v3.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M26.5 12.7l2.3.4.1 52.6-2.3-.4z" />
      </g>
    </svg>
  );
};
